<template>
  <div class="classify">
    <!-- 导航栏 -->
    <van-nav-bar :border="false" :placeholder="true" title="分类专区" :fixed="true" z-index="10">
      <van-icon name="arrow-left" slot="left" size=".7rem" color="#FF9D11" @click="onBack" />
    </van-nav-bar>
    <div class="classify-wrapper">
      <!-- 选项卡 -->
      <div class="scroll-tabs">
        <scroll ref="wrapper" :probeType="3">
          <ul class="classify-tabs">
            <li
              class="classify-tab"
              v-for="(item,index) in tabsList"
              :key="index"
              :class="active===index?'active':''"
              @click="tabClick(index,item.id)"
            >{{item.type_name}}</li>
          </ul>
        </scroll>
      </div>
      <!-- 选项卡对应的内容 -->
      <div class="scroll-tabs-cont">
        <scroll
          ref="wrapper"
          :pullUpLoad="loading"
          :data="arrList"
          :probeType="3"
          @pullingUp="pullingUp"
        >
          <div class="classify-tabs-cont" ref="tabsCont">
            <div class="dis-game" v-for="(item,index) in arrList" :key="index">
              <div class="i-game" @click="gameDateil('gamedetails',{gameid: item.gid})">
                <img v-lazy="item.icon_url" />
              </div>
              <div class="game-des" @click="gameDateil('gamedetails',{gameid: item.gid})">
                <div class="game-name-size">
                  <span class="name">{{item.game_name}}</span>
                </div>
                <div class="type-size">
                  <span
                    v-for="(item,index) in gameType(item.game_type_name)"
                    :key="index"
                    v-show="index==0"
                  >{{item}}</span>
                  <span class="line">|</span>
                  <span>{{item.package_size}}</span>
                </div>
                <div class="game-title">
                  <span>{{item.short_info}}</span>
                </div>
                <div class="dis-num">
                  <span v-for="(_item,index) in gameType(item.game_label)" :key="index">{{_item}}</span>
                </div>
              </div>
              <div class="game-down">
                <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
                <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
              </div>
            </div>
            <div class="noData" v-show="finished">没有更多了</div>
          </div>
        </scroll>
      </div>
    </div>
  </div>
</template>

<script>
import Scroll from "@components/com/BScroll/Scroll";
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "classify",
  mixins: [contTools, lyTool],
  components: {
    Scroll
  },
  data() {
    return {
      tabsList: [], // 类型列表
      active: 0, // tab选中标志
      arrList: [],
      scroll1: null,
      loading: true, // 禁止上拉加载
      finished: false, // 加载完成
      type_id: "", // 类型
      lastPage: "" // 最后一页
    };
  },
  created() {
    this.typesList();
  },
  mounted() {
    this.addPaddingBottom(this.$refs.tabsCont, "2.5rem");
    console.log("tabsCont", this.$refs.tabsCont.style);
  },
  methods: {
    // 切换选项卡
    tabClick(index, typeId) {
      this.active = index;
      this.type_id = typeId;
      this.page = 1;
      this.arrList = [];
      this.loading = true;
      this.pullingUp(typeId);
      // this.typesList();
    },
    // 获取游戏分类列表
    typesList() {
      let data = comTools.assignObj(this.wapConfig(), {});
      data.sign = comTools.querySort(data);
      wapApiFun.typesList(data).then(res => {
        if (res.code == 200) {
          this.tabsList = res.data;
          this.type_id = this.tabsList[0].id;
          this.pullingUp(this.type_id);
        }
      });
    },
    // 上拉加载
    pullingUp(typeId) {
      if (!this.loading) return;
      typeId = typeId || this.type_id;
      // console.log("pull", typeId);
      let data = comTools.assignObj(this.wapConfig(), {
        type_id: typeId,
        page: this.page
      });
      data.sign = comTools.querySort(data);
      wapApiFun.classifyList(data).then(res => {
        // console.log("游戏列表", res);
        if (res.code == 200) {
          let dataList = res.data.data;
          this.arrList = this.arrList.concat(dataList);
          this.page++;
          // if (this.page > res.data.last_page) return;
          this.lastPage = res.data.last_page;
          if (this.arrList.length >= res.data.total) {
            this.loading = false;
            this.finished = true;
            // console.log("到了", this.loading);
          } else {
            this.$refs.wrapper.finishPullUp();
          }
        }
      });

      // this.$refs.wrapper.finishPullUp()
    },
    // 返回上一级
    onBack() {
      this.$router.go(-1);
    }
    // 添加底部高度
  },
  // 导航守卫(离开当前时)
  beforeRouteLeave(to, from, next) {
    if (to.name == "gameDetails") {
      console.log("详情");
      from.meta.keepAlive = true;
      next();
    } else {
      console.log("游戏");
      from.meta.keepAlive = false;
      next();
    }

    // console.log(to, from);
    // if (to.name === "home") {
    //   from.meta.keepAlive = false;
    //   next();
    // } else {
    //   from.meta.keepAlive = false;
    //   this.$destroy(); //销毁B的实例
    //   next(); //当我们前进的不是C时我们让B页面刷新
    // }
    next();
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.classify {
  position: relative;
  width: 100%;
  height: 100vh;
  /deep/.van-nav-bar__title {
    font-weight: bold;
  }
  .classify-wrapper {
    position: absolute;
    left: 0;
    top: 46px;
    right: 0;
    bottom: 0;
    display: flex;
    // 选项卡
    .scroll-tabs {
      width: 2.5rem;
      position: relative;
      .scroll-wrapper {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        // 选项卡
        .classify-tabs {
          width: 100%;
          background-color: #efefef;
          color: #999;
          padding-bottom: 2.5rem;
          .classify-tab {
            padding: 0.5rem 0;
            text-align: center;
          }
          .active {
            .theme-bg-color();
            color: #fff;
          }
        }
      }
    }
    // 选项卡内容
    .scroll-tabs-cont {
      width: 100%;
      position: relative;
      .scroll-wrapper {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        .classify-tabs-cont {
          display: flex;
          flex-direction: column;
          align-items: center;
          // padding-bottom: 2.5rem;
          .dis-game {
            width: 100%;
            position: relative;
            margin-bottom: 0.5rem;
            .jc-content(flex-start);
            .i-game {
              width: 18%;
              margin: 0 0.3rem;
              img {
                .img();
              }
            }
            .game-des {
              min-width: 50%;
              flex-direction: column;
              display: flex;
              .game-name-size {
                .name {
                  font-size: 0.5rem;
                  padding-right: 0.3rem;
                }
              }
              .type-size {
                .font-color();
                font-size: 0.25rem;
                .line {
                  padding: 0 3px;
                }
              }
              // .game-type {
              //   color: #999;
              //   margin-bottom: 0.1rem;
              //   span {
              //     padding-right: 0.2rem;
              //     font-size: 0.4rem;
              //   }
              // }
              .game-title {
                width: 100%;
                color: #999;
                font-size: 0.3rem;
                // padding-bottom: 0.1rem;
                span {
                  display: inline-block;
                  width: 80%;
                  .ellipsis();
                }
              }
              .dis-num {
                display: flex;
                span {
                  font-size: 0.25rem;
                  // border-radius: 0.2rem;
                  // display: inline-block;
                  padding: 1px 0.2rem;
                  margin-right: 0.2rem;
                  &:nth-of-type(1) {
                    color: #d4704e;
                    background-color: #feedde;
                  }
                  &:nth-of-type(2) {
                    color: #666;
                    background-color: #f5f5f5;
                  }
                  &:nth-of-type(3) {
                    color: #d4704e;
                    background-color: #feedde;
                  }
                }
              }
            }
            .game-down {
              position: absolute;
              right: 0.3rem;
              top: 50%;
              transform: translate(0, -50%);
              .theme-bg-color();
              border-radius: 0.2rem;
              padding: 0.1rem 0.4rem;
              a {
                color: #fff;
              }
            }
            // &:last-child {
            //   margin-bottom: 1.5rem;
            // }
          }
          .noData {
            width: 100%;
            text-align: center;
            .font-color();
            font-size: 0.4rem;
            // padding-top: 0.2rem;
            padding-bottom: 0.5rem;
          }
        }
      }
    }
  }
}
</style>